import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
const PageHeader = React.forwardRef(function PageHeader2({ title, subtitle, actions, headingLevel = 1, titleId, className, ...rest }, ref) {
  const Heading = headingLevel === 2 ? "h2" : "h1";
  const hasActions = actions != null && actions !== false;
  return /* @__PURE__ */ jsxs("div", { ref, className: cx("ev-page-header", className), ...rest, children: [
    /* @__PURE__ */ jsxs("div", { className: "ev-page-header__text", children: [
      /* @__PURE__ */ jsx(Heading, { className: "ev-title", id: titleId, children: title }),
      subtitle != null && subtitle !== false ? /* @__PURE__ */ jsx("div", { className: "ev-muted", children: subtitle }) : null
    ] }),
    hasActions ? /* @__PURE__ */ jsx("div", { className: "ev-page-header__actions", children: actions }) : null
  ] });
});
export {
  PageHeader
};
//# sourceMappingURL=PageHeader.js.map
